import { PILLARS } from '../constants';

// Turns a history payload into a CSV string. Format:
//   Date,Composite,Speed,Attention,Memory,Flexibility,Problem Solving
//   2026-01-05,74,78,72,68,71,79
export function historyToCsv(entries) {
  const header = ['Date', 'Composite', ...PILLARS.map((p) => p.label)];
  const rows = (entries || []).map((e) => {
    const dateIso = new Date(e.takenAt).toISOString().slice(0, 10);
    const composite = e.composite ?? '';
    const pillarScores = PILLARS.map((p) => {
      const match = (e.pillars || []).find((x) => x.id === p.id);
      return match?.score ?? '';
    });
    return [dateIso, composite, ...pillarScores];
  });
  const lines = [header, ...rows].map((cols) =>
    cols.map((cell) => escapeCsvCell(cell)).join(',')
  );
  return lines.join('\n');
}

function escapeCsvCell(cell) {
  const s = String(cell ?? '');
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

// Triggers a browser download of the given CSV under a suggested filename.
export function downloadCsv(csv, filename = 'g-score-history.csv') {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Release the object URL after a tick so the download can start.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
